import { useChatboxStore } from "../../store";
import { openImageViewer } from "@/components/image/ImageViewer";
import type { MessagingMessage } from "@/model/messaging";

export const Image = ({ message }: { message: MessagingMessage }) => {
  const {
    use: { images },
  } = useChatboxStore();

  const openImage = () => {
    openImageViewer({
      images,
      index: images.findIndex((image) => image.message.uid === message.uid),
    });
  };

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={message.payload.media?.mediaUrl}
      alt={message.payload.media?.altText}
      className="min-h-10 min-w-10"
      onClick={openImage}
    />
  );
};
